import { defineAsyncComponent } from 'vue'

export const ModalDeleteAccount = defineAsyncComponent(() => import('../ModalDeleteAccount.vue'))
